import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-velo-trottinette',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent],
  templateUrl: './assurance-velo-trottinette.component.html',
  styleUrls: ['./assurance-velo-trottinette.component.scss']
})
export class AssuranceVeloTrottinetteComponent {
  title = 'Assurance Vélo - Trottinette Électrique';
  subtitle = '';
  heroImage = 'assets/static_pages_images/velo.jpg';
  
  breadcrumbs = [
    { label: 'Particuliers', link: undefined },
    { label: 'Assurance Vélo & Trottinette', link: undefined }
  ];

  prevPage = { 
    title: 'Assurance Chiens - Chats - Animaux',
    link: '/assurance-animaux'
  };

  nextPage = { 
    title: 'Je ne sais pas',
    link: '/contact'
  };

  constructor(private router: Router) {}
}
